import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7aa04e86&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=7aa04e86&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa04e86",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7aa04e86')) {
      api.createRecord('7aa04e86', component.options)
    } else {
      api.reload('7aa04e86', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7aa04e86&scoped=true", function () {
      api.rerender('7aa04e86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/teacherPower/index.vue"
export default component.exports